import ReactCountryFlag from 'react-country-flag';

const flagStyle = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  verticalAlign: 'initial',
};

export default function CountryFlag({ countryCode }) {
  return (
    <div className="country-flag">
      <ReactCountryFlag countryCode={countryCode} style={flagStyle} svg />
    </div>
  );
}
